import { defer } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import { logger } from '$utils'
import useComplianceStore from '../../store'

export default async function loader({ params }) {
  logger.debug(
    '[loader] About to await AppState being ready in Edit Pay Classification loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Edit Pay Cassification loader'
  )

  const getPayClassification = params.payClassificationId
    ? useComplianceStore
        .getState()
        .getPayClassification(params.payClassificationId)
    : null

  return defer({
    data: Promise.all([getPayClassification])
      .then(() => true)
      .catch((error) => {
        logger.error('Edit Pay Classification Promise.all error', error)
        return false
      }),
  })
}
